import * as React from 'react';

const styles = require('./index.css');

export class HasVideoBadge extends React.PureComponent<{}, {}> {
  public render() {
    return <i className={styles['badge']} data-tooltip-text="Объявление с видео" />;
  }
}
